// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1eJWb","event-title":"Merky","card-added-at":"_2lN44","key-events":"_3iF-I","events":"t6jxw","clock-icon":"_2LfTt","key-event-wrapper":"zV4Pp"};